import { combineReducers } from "redux";
import blogsReducer from "./blogs/reducer";
import filtersReducer from "./filter/reducer";

const rootReducer = combineReducers({
  blogs: blogsReducer,
  filters: filtersReducer,
});

export default rootReducer;
